var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('echart',{ref:"echart",staticStyle:{"width":"100%"},attrs:{"options":_vm.chart.options,"ng-if":"chart && chart.options && chart.render","autoresize":true,"rendered":_vm.rendered(),"finished":_vm.rendered()}})}
var staticRenderFns = []

export { render, staticRenderFns }